import React from "react";

import Navbar from "./Navbar";
import Footer from "./Footer";

import "./styles/AboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-page-wrapper">

      <Navbar />

      {/* HERO */}

      <section className="about-hero-section">

        <p className="about-mini-title">
          ABOUT GENESIS TECH ENGINEERS
        </p>

        <h1 className="about-main-title">
          Engineering Innovation <br />
          Through Technology & Automation
        </h1>

        <p className="about-description">
          Genesis Tech Engineers Pvt. Ltd. combines engineering expertise,
          enterprise software solutions, and intelligent automation to build
          scalable systems for modern industries and organizations.
        </p>

      </section>

      {/* COMPANY STORY */}

      <section className="about-story-section">

        <div className="about-story-left">

          <p className="about-section-tag">
            OUR STORY
          </p>

          <h2>
            Building Enterprise Solutions <br />
            for the Future
          </h2>

          <p>
            Genesis Tech Engineers Pvt. Ltd. was founded with the vision
            of delivering innovative engineering and technology-driven
            solutions across multiple industries including infrastructure,
            semiconductor facilities, electrical systems, HVAC,
            process engineering, and enterprise software development.
          </p>

          <p>
            Over the years, the company has expanded its expertise into
            intelligent software platforms, workflow automation,
            cloud systems, and enterprise workforce management solutions.
          </p>

        </div>

        <div className="about-story-right">

          <div className="about-stat-card">
            <h3>15+</h3>
            <p>Years Industry Experience</p>
          </div>

          <div className="about-stat-card">
            <h3>50+</h3>
            <p>Enterprise Projects</p>
          </div>

          <div className="about-stat-card">
            <h3>100%</h3>
            <p>Client-Focused Approach</p>
          </div>

          <div className="about-stat-card">
            <h3>24/7</h3>
            <p>Technology Support</p>
          </div>

        </div>

      </section>

      {/* MISSION */}

      <section className="about-mission-section">

        <div className="mission-card">

          <h2>Our Mission</h2>

          <p>
            To empower organizations through intelligent engineering,
            enterprise automation, and scalable workforce management solutions
            that improve operational efficiency and business growth.
          </p>

        </div>

        <div className="mission-card">

          <h2>Our Vision</h2>

          <p>
            To become a globally trusted technology and engineering company
            delivering next-generation enterprise systems for modern industries.
          </p>

        </div>

      </section>

      {/* EXPERTISE */}

      <section className="about-expertise-section">

        <p className="about-section-tag">
          OUR EXPERTISE
        </p>

        <h2 className="expertise-title">
          Multi-Domain Engineering <br />
          & Enterprise Technology Solutions
        </h2>

        <div className="expertise-grid">

          <div className="expertise-card">
            <span>⚡</span>
            <h3>Electrical Engineering</h3>
          </div>

          <div className="expertise-card">
            <span>🏗</span>
            <h3>Infrastructure Design</h3>
          </div>

          <div className="expertise-card">
            <span>🧠</span>
            <h3>Enterprise Software</h3>
          </div>

          <div className="expertise-card">
            <span>☁</span>
            <h3>Cloud Solutions</h3>
          </div>

          <div className="expertise-card">
            <span>📊</span>
            <h3>HRMS Automation</h3>
          </div>

          <div className="expertise-card">
            <span>🔐</span>
            <h3>Cyber Security</h3>
          </div>

        </div>

      </section>

      {/* LEADERSHIP */}

      <section className="about-leadership-section">

        <p className="about-section-tag">
          LEADERSHIP
        </p>

        <h2 className="leadership-title">
          Visionaries Driving Innovation
        </h2>

        <div className="leadership-grid">

          <div className="leader-card">

            <div className="leader-avatar">
              A
            </div>

            <h3>Ankur Patil</h3>

            <span>Founder & CEO</span>

            <p>
              Leading engineering innovation and enterprise project execution
              with expertise in mechanical engineering and semiconductor infrastructure.
            </p>

          </div>

          <div className="leader-card">

            <div className="leader-avatar">
              S
            </div>

            <h3>Shubham Patil</h3>

            <span>Co-Founder & CTO</span>

            <p>
              Driving technology innovation, software architecture,
              cloud systems, and enterprise platform development.
            </p>

          </div>

        </div>

      </section>

      <Footer />

    </div>
  );
};

export default AboutPage;